__turbopack_context__.v({
  "button": "index-module__puUF7G__button",
  "buttonToolbar": "index-module__puUF7G__buttonToolbar",
  "container": "index-module__puUF7G__container",
  "content": "index-module__puUF7G__content",
  "icon": "index-module__puUF7G__icon",
});
